var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"max-width":"700","has-padding":false},on:{"input":_vm.emitInput},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',[_c('app-vpn-support-body',{on:{"close":function($event){_vm.show = false}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }